const PIXEL_ID = '2025373898394216'

let initialized = false
let pending = false

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
  }
}

function loadPixel() {
  if (initialized || typeof window === 'undefined') return
  ;(function (f: any, b: any, e: any, v: any) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = !0
    t.defer = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
  initialized = true
}

export function initPixel() {
  if (initialized || pending || typeof window === 'undefined') return
  pending = true

  // Defer until browser is idle to avoid competing with first paint / hero render.
  const start = () => {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(loadPixel, { timeout: 3000 })
    } else {
      setTimeout(loadPixel, 1500)
    }
  }

  if (document.readyState === 'complete') {
    start()
  } else {
    window.addEventListener('load', start, { once: true, passive: true })
  }
}

export function trackInitiateCheckout() {
  if (typeof window === 'undefined') return
  // If pixel hasn't loaded yet, force-load synchronously before tracking
  if (!initialized) {
    loadPixel()
  }
  try {
    window.fbq &&
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Sistema iPhone Ads',
        content_category: 'Ebook / Guía digital',
        currency: 'ARS',
        value: 14900,
      })
  } catch (e) {
    // silent fail
  }
}
